import { render, staticRenderFns } from "./FormPartnership.vue?vue&type=template&id=29e30682&scoped=true"
import script from "./FormPartnership.vue?vue&type=script&lang=js"
export * from "./FormPartnership.vue?vue&type=script&lang=js"
import style0 from "./FormPartnership.vue?vue&type=style&index=0&id=29e30682&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e30682",
  null
  
)

export default component.exports